import i18n from "./i18n/i18n"

let messages = {
	ar: {
		required: 'هذا الحقل إجباري',
		numeric: 'قيمة رقمية خاطئة',
		email: 'بريد إلكتروني خاطئ',
		phone: 'رقم هاتف خاطئ',
		percentage: 'قيمة مئوية خاطئة',
		password: 'كلمة المرور هي 6 محارف على الأقل',
		username: 'استخدم الأبجدية الإنكليزية فقط ودون الانتهاء أو البدء بعلامة ترقيم',
		date: 'تاريخ خاطئ',
		money: 'قيمة مالية خاطئة',
		language: 'يجب تحديد اللغة',
		noBlankspace: 'إدخال خاطئ، استعِض عن الفراغ بنقطة أو شارطة أو شارطة سفلية',
	},
	en: {
		required: 'Required field',
		numeric: 'Incorrect numerical value',
		email: 'Unvalid email',
		phone: 'Unvalid phone number',
		percentage: 'Incorrect percent value',
		password: 'The password must be at least 6 characters',
		username: 'Use only the english letters with no punctuation marks at the beginning or end',
		date: 'Unvalid date',
		money: 'Unvalid financial value',
		language: 'Language is required',
		noBlankspace: 'Incorrect input, replace the space with a dot, hyphen, or underscore',
	},
	es: {
		required: 'Campo requerido',
		numeric: 'Valor numérico incorrecto',
		email: 'Correo electronico incorrecto',
		phone: 'Móvil incorrecto',
		percentage: 'Valor porcentual incorrecto',
		password: 'La contraseña debe tener al menos 6 caracteres',
		username: 'Use solo el alfabeto inglés sin terminar o comenzar con un signo de puntuación',
		date: 'Fecha incorrecta',
		money: 'Valor financiero incorrecto',
		language: 'Seleccione idioma',
		noBlankspace: 'Entrada incorrecta, reemplace el espacio con un punto, guión o guión bajo',
	},
}

export default {
	rules: {
		required: value => !!value || messages[i18n.locale].required,
		numeric: value => !value || !isNaN(parseFloat(value)) && isFinite(value) || messages[i18n.locale].numeric,
		email: value => {
			if(!value == ""){
			const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			return pattern.test(value) || messages[i18n.locale].email
			}
			return true;
		},
		phone: value => {
			if(!value == ""){
				const pattern = /^[+]?[(]?[0-9]{1,3}[)]?[-\s.]?[0-9]{1,4}[-\s.]?[0-9]{1,4}[-\s.]?[0-9]{4,12}$/
				return pattern.test(value) || messages[i18n.locale].phone
			}
			return true;
		},
		percentage: value => {
			if(!value == ""){
					var x = parseFloat(value);
						return !isNaN(x) && x > 0 && x < 100 || messages[i18n.locale].percentage
			}
			return true;
		},
		nonEmpty: value => value.length > 0 || messages[i18n.locale].required,
		password: value => value?.length >= 6 || messages[i18n.locale].password,
		username: (value) => 
		{
			if(!value == ""){
			const pattern = /^[a-zA-Z0-9]+([_ . -]?[a-zA-Z0-9])*$/
			return pattern.test(value) || messages[i18n.locale].username
			}
			return true
		},
		date: value =>{ 
			const pattern = /^\d{4}[/-](0?[1-9]|1[012])[/-](0?[1-9]|[12][0-9]|3[01])$/
			return  pattern.test(value) || messages[i18n.locale].date
		},
		money: value => {
			if(!value == ""){
				const pattern = /^(\d{1,3},?)*(\.\d+)?$/
				return pattern.test(value) || messages[i18n.locale].money
			}
			return true;
		},
		language: value => value > 0 || messages[i18n.locale].language,
		noBlankspace: (value) => value && !value.includes(' ') || messages[i18n.locale].noBlankspace
	},
}